import { breakpoints } from '@frontend/responsiveness';

export const SIDEBAR_BREAKPOINTS = {
  mobile: 650,
  tablet: breakpoints.medium.min,
  desktop: breakpoints.medium.max,
};
